import { UserDtoSchema } from "@modules/profile/userProfile/userDto"
import { SharedCoachStatus } from "@modules/programs/types/programTypes"
import { z } from "zod"

export const SharedCoachDtoSchema = z
  .object({
    role: z.string(),
    status: z.lazy(() => z.enum(SharedCoachStatus)),
    user: UserDtoSchema,
  })
  .meta({ id: "SharedCoachDtoSchema" })

export type SharedCoachDto = z.infer<typeof SharedCoachDtoSchema>

export enum SharedCoachRole {
  STANDARD = "STANDARD",
}
